import { useTranslation } from 'next-i18next'

import DrillTopicElementsList from '~/components/Drill/DrillTopic/components/DrillTopicElemetsList'
import DrillTopicGridLayout from '~/components/Drill/DrillTopic/components/DrillTopicGridLayout'
import DrillTopicGridWrapper from '~/components/Drill/DrillTopic/components/DrillTopicGridWrapper'
import LianaDesktop from '~/components/Drill/DrillTopic/components/LianaDesktop'
import LianaMobile from '~/components/Drill/DrillTopic/components/LianaMobile'
import LianaTablet from '~/components/Drill/DrillTopic/components/LianaTablet'
import useGetGridPositionFunction from '~/components/Drill/hooks/useGetGridPositionFunction'
import { TopicData } from '~/types/theory'
import { processTopics } from '~/components/Drill/DrillTopic/helpers'

import { getGridPosition } from './TheMultiplicationTable.grid'
import { getProperties } from './TheMultiplicationTable.properties'

export default function TheMultiplicationTable({
  topics,
  drillUrl,
}: {
  topics: TopicData[] | undefined
  drillUrl: string
}): React.ReactElement {
  const { t } = useTranslation(['drill'])
  const getGridPositionFunction = useGetGridPositionFunction(getGridPosition)
  const processedTopics = processTopics(topics, getGridPositionFunction, getProperties)

  const mobileGridRows = 'grid-rows-[repeat(12,70px)]'
  const tabletGridRows = 'md:grid-rows-[repeat(6,70px)]'
  const desktopGridRows = 'xl:grid-rows-[repeat(6,70px)]'

  return (
    <DrillTopicGridWrapper>
      <div className="hidden xl:block">
        <LianaDesktop
          classNames="-top-24 -left-4 w-[785px]"
          image="math-drills/the-multiplication-table/beanstalk-desktop.png"
          imageAlt={t('drill:imageAlt.mulTableBeanStalkDesktop')}
        />
      </div>
      <div className="md:hidden">
        <LianaMobile height={1200} />
      </div>
      <div className="hidden md:block xl:hidden">
        <LianaTablet
          height={547}
          image="math-drills/the-multiplication-table/beanstalk-tablet.png"
          imageAlt={t('drill:imageAlt.mulTableBeanStalkTablet')}
        />
      </div>
      <DrillTopicGridLayout className={[mobileGridRows, tabletGridRows, desktopGridRows].join(' ')}>
        <DrillTopicElementsList drillUrl={drillUrl} topics={processedTopics} />
      </DrillTopicGridLayout>
    </DrillTopicGridWrapper>
  )
}
